import {ComparableSale} from '$src/bootstrap/Store'

export interface ServerSnapshot {
  version: number
  housingCorporationId: string
  tabs: Array<{
    name: string
    id: string
    enabled: boolean
    query: any
    foundItems: {
      queried: boolean
      selectedPageSize: undefined | number
    }
    data: Array<typeof ComparableSale.SnapshotType & {disabled: boolean}>
  }>
}

export default function setComparableSaleResearchState(
  {post}: any,
  body: ServerSnapshot,
): Promise<{}> {
  return post(`/comparable-sale-data`, body, {retryOn401: true})
}



// WEBPACK FOOTER //
// ./src/api/endpoints/comparableSaleResearchState/setComparableSaleResearchState.tsx